//ここはぜん
import "../style/main.scss"
import "./base.js"
console.log("welcome common.ts")
